module.exports = __webpack_public_path__ + "static/media/ic_dustbin_unselected_state.37021466.svg";